
import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface KpiInputPanelProps {
  kpiType: string;
  setKpiType: (value: string) => void;
  kpiTitle: string;
  setKpiTitle: (value: string) => void;
  kpiDescription: string;
  setKpiDescription: (value: string) => void;
  addKPINode: () => void;
  isDisabled?: boolean;
}

const KpiInputPanel = ({
  kpiType,
  setKpiType,
  kpiTitle,
  setKpiTitle,
  kpiDescription,
  setKpiDescription,
  addKPINode,
  isDisabled = false
}: KpiInputPanelProps) => {
  // Set the default kpiType to "solutions" when the component is first rendered
  React.useEffect(() => {
    setKpiType("solutions");
  }, []);

  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-white">Add:</span>
        <Select value={kpiType} onValueChange={setKpiType} disabled={isDisabled}>
          <SelectTrigger className="w-[200px] bg-white text-black">
            <SelectValue placeholder="Potential Solutions">Potential Solutions</SelectValue>
          </SelectTrigger>
          <SelectContent className="bg-white text-black">
            <SelectItem value="solutions">Potential Solutions</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-white">Title:</span>
        <Input 
          value={kpiTitle} 
          onChange={e => setKpiTitle(e.target.value)} 
          placeholder="Enter Potential Solution title" 
          className="w-[200px] bg-white text-black" 
          disabled={isDisabled}
        />
      </div>

      <div className="flex items-center gap-2 flex-1">
        <span className="text-sm font-medium text-white">Description:</span>
        <Input 
          value={kpiDescription} 
          onChange={e => setKpiDescription(e.target.value)} 
          placeholder="Enter Potential Solution description" 
          className="flex-1 bg-white text-black" 
          disabled={isDisabled}
        />
      </div>

      <Button 
        onClick={addKPINode} 
        className="bg-primary hover:bg-primary/90 text-black"
        disabled={isDisabled}
      >
        Add Solution
      </Button>
    </div>
  );
};

export default KpiInputPanel;
